import { createContext, type Context } from 'react';

export const CommentsPanelPermissionContext: Context<boolean | undefined> = createContext<
	boolean | undefined
>(undefined);
